import React from 'react';

import ReactQuill, { Quill } from 'react-quill';
import ImageResize from '@capaj/quill-image-resize-module-react';

const Editor: React.FC<{ value; callback }> = ({ value, callback }) => {
  Quill.register('modules/imageResize', ImageResize);

  const modules = {
    imageResize: {
      parchment: Quill.import('parchment'),
    },
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['link', 'image', 'video'],
      ['clean'],
    ],
  };
  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'align',
    'bullet',
    'indent',
    'link',
    'image',
    'video',
  ];

  return (
    <ReactQuill
      style={{ border: 'none', borderRadius: '10px' }}
      theme="snow"
      value={value}
      modules={modules}
      formats={formats}
      preserveWhitespace
      onChange={(val, _, source) => {
        if (source === 'user') callback(val);
      }}
    />
  );
};

export default Editor;
